<template>
  <div>
    <template v-if="course">
      <div class="fill bg-blue">
        <course-top-header :course="course" />
        <course-header :course="course" />
        <course-enroll-button :course="course" />
      </div>
      <router-view />
    </template>
    <div v-else>
      <skeleton :lines="7" />
      <skeleton :lines="20" style-class="mt-24" />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CourseHeader from "../components/course/CourseHeader.vue";
import CourseTopHeader from "../components/course/CourseTopHeader.vue";
import Skeleton from "../components/Skeleton.vue";
import CourseEnrollButton from "../components/course/CourseEnrollButton.vue";

export default {
  name: "CoursePage",
  components: {
    CourseEnrollButton,
    Skeleton, CourseTopHeader, CourseHeader
  },
  async mounted() {
    await this.getCourse(this.$route.params.id)
  },
  methods: {
    ...mapActions(['getCourse'])
  },
  computed: {
    ...mapGetters(['course'])
  },
  watch: {
    '$route.params.id'(val) {
      this.getCourse(val)
    },
    '$i18n.locale'() {
      // Перезагружаем курс при изменении языка
      if (this.$route.params.id) {
        this.getCourse(this.$route.params.id)
      }
    }
  }
}
</script>